import Immutable from 'seamless-immutable';
import {
  ADD_FILTRO_PANEL,
  CHANGE_ADD_PRODUCT_PANEL,
  CHANGE_CACHE_PANEL,
  CHANGE_CHECK_ALL_PRODUCT,
  CHANGE_NO_CACHE_VALUE,
  CHANGE_REMOVE_PRODUCT_PANEL,
  CHANGE_VALUE_PANEL,
  CLEAR_FILTROS,
  CLEAR_FILTROS_DINAMICOS,
  CLEAR_FILTROS_PANEL,
  CLEAR_TOTALDATAPOINT,
  DELETE_FILTRO_ENDERECO,
  DELETE_FILTRO_PANEL,
  LIST_ENDERECO,
  LIST_ITENS_FILTROS_PANEL,
  LIST_PRODUTOS,
  SELECT_VALUE_PANEL,
  SET_AD,
  SET_CHANNEL,
  SET_CUSTOM_FILTER_LIST,
  SET_DATA,
  SET_DATA_BOXPLOT,
  SET_DATA_MAP,
  SET_DATA_TIME_EVOLUTION,
  SET_ERRO_PAINEL_GERAL,
  SET_FILTRO_SALVO_ENDERECO,
  SET_FILTROS_SALVOS,
  SET_FILTROS_SALVOS_LOADING,
  SET_FILTROS_SALVOS_PANEL,
  SET_LAT_LON,
  SET_LIMIT_PRODUCTS,
  SET_LIMIT_PRODUCTS_FILTROS_DATA,
  SET_LOADING_STATUS,
  SET_MARKERS_DATA,
  SET_PAINEL_GERAL_STATE,
  SET_PERIODO_TIME_EVOLUTION,
  SET_PRICE_FILTER,
  SET_PRODUCT_DASHBOARD_LIST,
  SET_SHARE_TOKENS_DATA,
  SET_SINGLE_REDUCER,
  SET_SORT_COLUMN_BOXPLOT,
  SET_TOP_FIVE_DATA,
  SET_TOTAL_DATAPOINTS,
  SET_USERS_EMAIL_DATA,
  SET_VISUALIZATION_TYPE_BOXPLOT,
  SET_VISUALIZATION_TYPE_MAP,
  SET_VISUALIZATION_TYPE_TIME_EVOLUTION,
} from '../actions/actionsPainelGeral';
import {
  PANEL_FILTER_DATA,
  PANEL_FILTER_TYPE_DATA,
  PANEL_RADIUS_DATA,
  PMC_SELECT_DATA,
  REBAIXA_PRECO_SELECT_DATA,
} from '../pages/ISA/InfoPanel/InfoPanel/data';
import { setCustomFilter_CACHE, setCustomFilter_LIST } from '../pages/ISA/InfoPanel/InfoPanel/utils';

const FILTER_PICKER_DATA = {
  lista: [],
  value: [],
  cache: [],
};

const painelGeralInitialState = Immutable({
  tiposFiltro: PANEL_FILTER_TYPE_DATA,
  filtros: PANEL_FILTER_DATA,
  filtrosAdicionados: [],
  filtrosData: {
    preco: {
      name: '',
    },
    tipoPreco: FILTER_PICKER_DATA,
    origemPreco: FILTER_PICKER_DATA,
    fabricante: FILTER_PICKER_DATA,
    marca: FILTER_PICKER_DATA,
    gramatura_descricao: FILTER_PICKER_DATA,
    fonteDigital: FILTER_PICKER_DATA,
    conteudo: FILTER_PICKER_DATA,
    tipoProduto: FILTER_PICKER_DATA,
    categoria: FILTER_PICKER_DATA,
    secao: FILTER_PICKER_DATA,
    rede: {
      lista: [],
      value: [],
      cache: [],
      erro: null,
    },
    tipoLoja: FILTER_PICKER_DATA,
    cnpj: FILTER_PICKER_DATA,
    uf: FILTER_PICKER_DATA,
    regiao: FILTER_PICKER_DATA,
    cidade: FILTER_PICKER_DATA,
    segmentosPersonalizados: FILTER_PICKER_DATA,
    mecanica: FILTER_PICKER_DATA,
    grupoMidia: FILTER_PICKER_DATA,
    midia: FILTER_PICKER_DATA,
    pmc: {
      lista: PMC_SELECT_DATA,
      value: [],
      cache: [],
    },
    marcaPropria: {
      lista: PMC_SELECT_DATA,
      value: [],
      cache: [],
    },
    produto: {
      lista: [],
      value: [],
      cache: [],
      limitProducts: null,
    },
    dataInicio: null,
    dataFim: null,
    endereco: {
      lista: [],
      value: '',
      token: null,
      latitude: null,
      longitude: null,
      erro: null,
    },
    raio: {
      lista: PANEL_RADIUS_DATA,
      value: null,
    },
    canal: ['Canal físico', 'Canal digital'],
    ad: false,
  },
  canal: ['Canal físico', 'Canal digital'],
  ad: false,
  raio: {
    lista: PANEL_RADIUS_DATA,
    value: null,
  },
  endereco: {
    lista: [],
    value: '',
    token: null,
    latitude: null,
    longitude: null,
    erro: null,
  },
  dataInicio: null,
  dataFim: null,
  produto: {
    lista: [],
    value: [],
    cache: [],
    limitProducts: null,
  },
  rede: {
    lista: [],
    value: [],
    cache: [],
    erro: null,
  },
  preco: {
    name: '',
  },
  tipoPreco: FILTER_PICKER_DATA,
  origemPreco: FILTER_PICKER_DATA,
  fabricante: FILTER_PICKER_DATA,
  marca: FILTER_PICKER_DATA,
  conteudo: FILTER_PICKER_DATA,
  tipoProduto: FILTER_PICKER_DATA,
  categoria: FILTER_PICKER_DATA,
  secao: FILTER_PICKER_DATA,
  tipoLoja: FILTER_PICKER_DATA,
  cnpj: FILTER_PICKER_DATA,
  uf: FILTER_PICKER_DATA,
  regiao: FILTER_PICKER_DATA,
  cidade: FILTER_PICKER_DATA,
  mecanica: FILTER_PICKER_DATA,
  grupoMidia: FILTER_PICKER_DATA,
  midia: FILTER_PICKER_DATA,
  pmc: {
    lista: PMC_SELECT_DATA,
    value: [],
    cache: [],
  },
  rebaixaPreco: {
    lista: REBAIXA_PRECO_SELECT_DATA,
    value: [],
    cache: [],
  },
  marcaPropria: {
    lista: PMC_SELECT_DATA,
    value: [],
    cache: [],
  },
  boxplot: {
    data: null,
    type: 'produto',
    sortColumn: null,
  },
  timeEvolution: {
    data: null,
    type: 'produto',
    periodo: 'SEMANA',
  },
  map: {
    data: null,
    type: 'estadual',
  },
  topFive: {
    data: {},
  },
  totalDatapoints: null,
  loadingBoxplot: true,
  loadingTimeEvolution: true,
  loadingMap: false,
  loadingTopFive: true,
  loadingProductDashboard: true,
  loadingProductDashboardTable: true,
  productDashboardList: [],
  productDashboardTableList: [],
  isLoadingFiltrosSalvos: false,
  showModalAnalisysPlan: false,
  showModalSpeakWithSpecialist: false,
  userContratoLimiteData: {},
  showModalProductWithoutUnitMeasurements: false,
  productsWithoutUnitMeasurement: [],
});

function painelGeralDataReducer(state = painelGeralInitialState, action) {
  switch (action.type) {
    case ADD_FILTRO_PANEL:
      return state.merge({
        filtrosAdicionados: [...state.filtrosAdicionados, action.filtro],
      });
    case DELETE_FILTRO_PANEL:
      return state.merge({
        filtrosAdicionados: state.filtrosAdicionados.filter((item, index) => index !== action.index),
        [action.name]: {
          ...state[action.name],
          value: [],
          disabled: [],
          cache: [],
        },
      });
    case DELETE_FILTRO_ENDERECO:
      return state.merge({
        filtrosAdicionados: state.filtrosAdicionados.filter((item, index) => index !== action.index),
        endereco: {
          ...state.endereco,
          value: [],
          disabled: [],
          erro: null,
          latitude: null,
          longitude: null,
        },
        raio: {
          ...state.raio,
          value: null,
        },
      });
    case SET_FILTRO_SALVO_ENDERECO:
      return state.merge({
        endereco: {
          ...state.endereco,
          value: action.data.endereco || '',
          latitude: action.data.latitude || null,
          longitude: action.data.longitude || null,
        },
        raio: {
          ...state.raio,
          value: action.data.raio || null,
        },
      });
    case CHANGE_VALUE_PANEL:
      return state.merge({
        ...state,
        filtrosData: {
          ...state.filtrosData,
          [`${action.name}`]: {
            ...state.filtrosData[`${action.name}`],
            value: action.value,
          },
        },
      });
    case CHANGE_CACHE_PANEL:
      return state.merge({
        ...state,
        filtrosData: {
          ...state.filtrosData,
          [`${action.name}`]: {
            ...state.filtrosData[`${action.name}`],
            cache: action.cache,
          },
        },
      });
    case SELECT_VALUE_PANEL:
      return state.merge({
        ...state,
        filtrosData: {
          ...state.filtrosData,
          [`${action.name}`]: {
            ...state.filtrosData[`${action.name}`],
            cache: [...state.filtrosData[`${action.name}`].cache, action.item],
          },
        },
      });

    case CHANGE_ADD_PRODUCT_PANEL:
      return state.merge({
        ...state,
        produto: {
          ...state.produto,
          value: [...state.produto.value, action.item.value],
          cache: [...state.produto.cache, action.item],
        },
      });
    case CHANGE_REMOVE_PRODUCT_PANEL:
      return state.merge({
        ...state,
        produto: {
          ...state.produto,
          value: state.produto.value.filter(i => i !== action.value),
          cache: state.produto.cache.filter(i => i.value !== action.value),
        },
      });
    case CHANGE_CHECK_ALL_PRODUCT:
      return state.merge({
        ...state,
        produto: {
          ...state.produto,
          value: action.value,
          cache: action.item,
        },
      });
    case LIST_ITENS_FILTROS_PANEL: // Módulo de relatório
      return state.merge({
        ...state,
        filtrosData: {
          ...state.filtrosData,
          [action.name]: {
            ...state.filtrosData[action.name],
            lista: setCustomFilter_LIST(action.name, action.itens, state.filtrosData[action.name]),
            cache: setCustomFilter_CACHE(action.name, action.itens, state.filtrosData[action.name]),
          },
        },
      });

    case LIST_PRODUTOS: {
      const mapProductItem = item => ({
        id: item.id,
        value: item.id,
        label: `${item.identificador} - ${item.descricao}`,
        identificador: item.identificador,
        descricao: item.descricao,
        secao: item.secao,
        categoria: item.categoria,
        datapoints: item.datapoints,
        limited: item.limited,
        foto: item.foto,
      });

      const notInActionList = cacheItem => !action.list.some(itemLista => itemLista.id === cacheItem.value);

      const mappedActionList = action.list.map(mapProductItem);
      const filteredCache = state.produto.cache.filter(notInActionList);

      const regularList = [...filteredCache, ...mappedActionList];
      const filteredList = [...mappedActionList, ...filteredCache];

      const shouldUpdateByIdentificadores = !!action.identificadores;

      const newCacheItems = shouldUpdateByIdentificadores
        ? action.list.filter(item => !state.produto.cache.some(c => c.value === item.id)).map(mapProductItem)
        : [];

      const updatedCache = shouldUpdateByIdentificadores ? [...state.produto.cache, ...newCacheItems] : state.produto.cache;

      const updatedValue = shouldUpdateByIdentificadores ? updatedCache.map(item => item.id) : state.produto.value;

      return state.merge({
        ...state,
        produto: {
          ...state.produto,
          lista: action.hasQuerySearch ? filteredList : regularList,
          cache: updatedCache,
          value: updatedValue,
        },
        isLoadingFiltrosSalvos: false,
      });
    }
    case LIST_ENDERECO:
      return state.merge({
        ...state,
        endereco: {
          ...state.endereco,
          lista: action.list.predictions.map(item => ({
            label: item.description,
            value: item.description,
            place_id: item.place_id,
          })),
          token: action.list.session_token,
        },
      });
    case SET_LAT_LON:
      return state.merge({
        ...state,
        endereco: {
          ...state.endereco,
          latitude: action.data.geometry.location.lat,
          longitude: action.data.geometry.location.lng,
        },
      });
    case SET_LIMIT_PRODUCTS:
      return state.merge({
        ...state,
        produto: {
          ...state.produto,
          limitProducts: action.value,
        },
      });
    case SET_DATA:
      return state.merge({
        ...state,
        dataInicio: action?.data[0] || null,
        dataFim: action?.data[1] || null,
      });
    case SET_ERRO_PAINEL_GERAL: {
      const updateAddedFilter = (name, message) => {
        const newList = state.filtrosAdicionados.map(filter => {
          if (filter.name === name) {
            return {
              ...filter,
              erro: message,
            };
          }
          return filter;
        });

        return newList;
      };
      return state.merge({
        ...state,
        filtrosAdicionados: updateAddedFilter(action.name, action.message),
      });
    }
    case SET_FILTROS_SALVOS:
      return state.merge({
        ...state,
        filtrosData: {
          ...state.filtrosData,
          [`${action.name}`]: {
            ...state.filtrosData[`${action.name}`],
            lista:
              state.filtrosData[`${action.name}`]?.lista?.findIndex(item => item.value === action.value) === -1
                ? [
                    ...state.filtrosData[`${action.name}`].lista,
                    {
                      label: action.value,
                      value: action.value,
                    },
                  ]
                : state.filtrosData[`${action.name}`]?.lista,
            cache:
              state.filtrosData[`${action.name}`]?.lista?.findIndex(item => item.value === action.value) === -1
                ? [
                    ...state.filtrosData[`${action.name}`].lista,
                    {
                      label: action.value,
                      value: action.value,
                    },
                  ]
                : state.filtrosData[`${action.name}`]?.lista,
          },
        },
      });
    case SET_FILTROS_SALVOS_PANEL:
      return state.merge({
        ...state,
        [action.name]: {
          ...state[action.name],
          lista:
            state[action.name]?.lista?.findIndex(item => item.value === action.value) === -1
              ? [
                  ...state[action.name].lista,
                  {
                    label: action.value,
                    value: action.value,
                  },
                ]
              : state[action.name]?.lista,
          cache:
            state[action.name]?.lista?.findIndex(item => item.value === action.value) === -1
              ? [
                  ...state[action.name].cache,
                  {
                    label: action.value,
                    value: action.value,
                  },
                ]
              : state[action.name]?.cache,
        },
      });
    case CLEAR_FILTROS:
      return state.merge({
        ...state,
        tiposFiltro: painelGeralInitialState.tiposFiltro,
        filtrosData: {
          ...painelGeralInitialState.filtrosData,
          dataInicio: state.filtrosData.dataInicio,
          dataFim: state.filtrosData.dataFim,
        },
        filtrosAdicionados: painelGeralInitialState.filtrosAdicionados,
      });
    case CLEAR_FILTROS_PANEL:
      const filters = action?.list?.reduce((acc, elem) => {
        acc[elem] = painelGeralInitialState[elem];
        return acc;
      }, {});
      return state.merge({
        ...state,
        ...filters,
        tiposFiltro: painelGeralInitialState.tiposFiltro,
        dataInicio: state.dataInicio,
        dataFim: state.dataFim,
        filtrosAdicionados: painelGeralInitialState.filtrosAdicionados,
      });
    case CLEAR_TOTALDATAPOINT:
      return state.merge({
        ...state,
        totalDatapoints: painelGeralInitialState.totalDatapoints,
      });
    case CLEAR_FILTROS_DINAMICOS:
      return state.merge({
        ...state,
        tiposFiltro: painelGeralInitialState.tiposFiltro,
        filtrosData: {
          ...painelGeralInitialState.filtrosData,
          // produto: state.filtrosData.produto,
          dataInicio: state.filtrosData.dataInicio,
          dataFim: state.filtrosData.dataFim,
        },
        produto: state.produto,
        filtrosAdicionados: painelGeralInitialState.filtrosAdicionados,
      });
    case SET_DATA_BOXPLOT:
      return state.merge({
        ...state,
        boxplot: {
          ...state.boxplot,
          data: action.data,
        },
        loadingBoxplot: false,
      });
    case SET_VISUALIZATION_TYPE_BOXPLOT:
      return state.merge({
        ...state,
        boxplot: {
          ...state.boxplot,
          type: action.visualizationType,
        },
      });
    case SET_SORT_COLUMN_BOXPLOT:
      return state.merge({
        ...state,
        boxplot: {
          ...state.boxplot,
          sortColumn: action.sortColumn,
        },
      });
    case SET_DATA_TIME_EVOLUTION:
      return state.merge({
        ...state,
        timeEvolution: {
          ...state.timeEvolution,
          data: action.data,
        },
        loadingTimeEvolution: false,
      });
    case SET_VISUALIZATION_TYPE_TIME_EVOLUTION:
      return state.merge({
        ...state,
        timeEvolution: {
          ...state.timeEvolution,
          type: action.visualizationType,
        },
      });
    case SET_PERIODO_TIME_EVOLUTION:
      return state.merge({
        ...state,
        timeEvolution: {
          ...state.timeEvolution,
          periodo: action.periodo,
        },
      });
    case SET_DATA_MAP:
      return state.merge({
        ...state,
        map: {
          ...state.map,
          data: action.data,
        },
        loadingMap: false,
      });
    case SET_MARKERS_DATA:
      return state.merge({
        ...state,
        map: {
          ...state.map,
          markers: action.data.content.map(item => ({
            lat: item.latitude,
            lng: item.longitude,
            rede: item.rede,
            price: item.preco_medio,
          })),
        },
        loadingMap: false,
      });
    case SET_VISUALIZATION_TYPE_MAP:
      return state.merge({
        ...state,
        map: {
          ...state.map,
          type: action.visualizationType,
        },
      });
    case SET_TOP_FIVE_DATA:
      return state.merge({
        ...state,
        topFive: {
          ...state.topFive,
          data: action.data,
        },
        loadingTopFive: false,
      });
    case SET_SHARE_TOKENS_DATA:
      return state.merge({
        ...state,
        shareTokens: {
          ...state.shareTokens,
          data: action.data,
        },
      });
    case SET_USERS_EMAIL_DATA:
      return state.merge({
        ...state,
        userEmails: {
          ...state.userEmails,
          data: action.data,
        },
      });
    case SET_TOTAL_DATAPOINTS:
      return state.merge({
        ...state,
        totalDatapoints: action.data,
      });
    case SET_PRICE_FILTER:
      return state.merge({
        ...state,
        preco: {
          name: action.data,
        },
      });
    case SET_CHANNEL:
      return state.merge({
        ...state,
        canal: action.data,
      });
    case SET_AD:
      return state.merge({
        ...state,
        ad: action.data,
      });
    case SET_LOADING_STATUS:
      return state.merge({
        ...state,
        [action.data.name]: action.data.status,
      });
    case SET_PAINEL_GERAL_STATE:
      return state.merge({
        ...state,
        [action.name]: action.data,
      });
    case SET_SINGLE_REDUCER:
      return state.merge({
        ...state,
        [action.name]: {
          ...state[action.name],
          value: action.value,
          cache: action.item,
        },
      });
    case SET_CUSTOM_FILTER_LIST:
      return state.merge({
        ...state,
        [action.name]: {
          ...state[action.name],
          lista: setCustomFilter_LIST(action.name, action.data, state[action.name]),
          cache: setCustomFilter_CACHE(action.name, action.data, state[action.name]),
        },
      });
    case CHANGE_NO_CACHE_VALUE:
      return state.merge({
        ...state,
        [action.name]: {
          ...state[action.name],
          value: action.value,
        },
      });
    case SET_LIMIT_PRODUCTS_FILTROS_DATA:
      return state.merge({
        ...state,
        filtrosData: {
          ...state.filtrosData,
          produto: {
            ...state.filtrosData.produto,
            limitProducts: action.value,
          },
        },
      });
    case SET_FILTROS_SALVOS_LOADING:
      return state.merge({
        ...state,
        isLoadingFiltrosSalvos: action.data,
      });
    case SET_PRODUCT_DASHBOARD_LIST: {
      const selectedProducts = state.produto?.cache;
      const hasUnitMeasurementPrice = new Set(action.data?.datapoints?.map(item => item.gtin));
      const products = selectedProducts?.filter(item => !hasUnitMeasurementPrice?.has(item.identificador));
      const priceType = state.preco?.name === 'PRECO_POR_UNIDADE_MEDIDA';

      return state.merge({
        ...state,
        productDashboardList: action.data,
        productsWithoutUnitMeasurement: priceType ? products : [],
      });
    }
    default:
      return state;
  }
}

export default painelGeralDataReducer;
